/**
 * An engine output. A plain `<td>` of text -- it accepts no `onChange` and
 * renders no form control, so a calculated value can never be typed over
 * (BR-F11.1-2, BR-F11.1-14).
 */

interface CalculatedCellProps {
  text: string;
  title?: string;
}

export function CalculatedCell({ text, title }: CalculatedCellProps) {
  return (
    <td className="col-calc num" title={title}>
      {text}
    </td>
  );
}
